import React from 'react'
import { defaultProps } from './index'
import CtaToolbarSection from 'react-pagebuilder/editor/Viewport/Sidebar/Toolbar/CtaToolbarSection'
import ImageToolbarSection from 'react-pagebuilder/editor/Viewport/Sidebar/Toolbar/ImageToolbarSection'

export const CategoriaHubCardSettings = (settingsProps) => {
  return (
    <>
      <div className="empty-message">
        <p>No options available</p>
      </div>
      {!settingsProps.floating && (
        <>
          <ImageToolbarSection defaultProps={defaultProps} />
          <CtaToolbarSection defaultProps={defaultProps} />
        </>
      )}
    </>
  )
}

export const CategoriaHubCardFloatingSettings = () =>
  React.createElement(CategoriaHubCardSettings, { floating: true })
